import { render, staticRenderFns } from "./ChipSkeleton.vue?vue&type=template&id=3546eaf7&"
import script from "./ChipSkeleton.vue?vue&type=script&lang=ts&"
export * from "./ChipSkeleton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QSkeleton} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QSkeleton})
